// 📁 src/components/DataTable.js
import React from "react";
import "../styles/rh-modern-ui.css";

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const DataTable = ({
  columns,
  data,
  emptyText = "Aucune donnée disponible",
  pageSize: initialPageSize = 10,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
  rowClassName,
  tableClassName = "",
  showPageSizeSelector = true,
}) => {
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(initialPageSize);

  const total = Array.isArray(data) ? data.length : 0;
  const pages = Math.max(1, Math.ceil(total / pageSize));

  React.useEffect(() => {
    setPage(1);
  }, [total, pageSize]);

  React.useEffect(() => {
    setPageSize(initialPageSize);
  }, [initialPageSize]);

  const start = (page - 1) * pageSize;
  const end = start + pageSize;
  const view = (Array.isArray(data) ? data : []).slice(start, end);

  const handlePageSizeChange = (e) => {
    const next = Number(e.target.value);
    setPageSize(next);
    setPage(1);
  };

  const from = total === 0 ? 0 : start + 1;
  const to = Math.min(end, total);

  return (
    <div className="datatable-modern">
      <div className="table-responsive datatable-modern-scroll">
        <table className={`table modern-table datatable-modern-table ${tableClassName}`.trim()}>
          <thead>
            <tr>
              {columns.map((col, i) => (
                <th key={i} style={{ whiteSpace: "nowrap" }}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {view.length > 0 ? (
              view.map((row, i) => {
                const rowCls = rowClassName ? rowClassName(row) : "";
                return (
                  <tr key={row.id_contrat ?? row.id_departement ?? row.id_ville ?? row.id_employe ?? row.id_user ?? row.value ?? i} className={rowCls}>
                    {columns.map((col, j) => (
                      <td key={j}>{col.render ? col.render(row) : row[col.field]}</td>
                    ))}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length} className="text-center datatable-empty">
                  {emptyText}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="datatable-footer">
        <div className="datatable-footer-meta">
          <span className="datatable-range">
            {total > 0 ? (
              <>Affichage <strong>{from}</strong>–<strong>{to}</strong> sur <strong>{total}</strong></>
            ) : (
              <>Aucun élément</>
            )}
          </span>
          {showPageSizeSelector && (
            <label className="datatable-pagesize">
              <span>Lignes</span>
              <select
                className="form-select form-select-sm"
                value={pageSize}
                onChange={handlePageSizeChange}
                aria-label="Nombre de lignes par page"
              >
                {pageSizeOptions.map((n) => (
                  <option key={n} value={n}>{n}</option>
                ))}
              </select>
            </label>
          )}
        </div>
        <div className="datatable-pagination">
          <button
            type="button"
            className="btn btn-sm datatable-page-btn"
            disabled={page <= 1}
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            aria-label="Page précédente"
          >
            Précédent
          </button>
          <span className="datatable-page-indicator">
            Page {page} / {pages}
          </span>
          <button
            type="button"
            className="btn btn-sm datatable-page-btn"
            disabled={page >= pages}
            onClick={() => setPage((p) => Math.min(pages, p + 1))}
            aria-label="Page suivante"
          >
            Suivant
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataTable;
